<template>
	<div class="berita">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'Berita'
}
</script>